import React, { useState, useEffect } from 'react';
import BotoneraDesplegable from '../../UI/BotoneraDesplegable.js';
import MensajeCargando from '../../UI/MensajeCargando.js';
import MensajeError from '../../UI/MensajeError.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import * as Funciones from '../../funciones/FuncionesTorneos.js';
import { Torneo as Filtros } from '../../constantes/Filtros.js';
import styles from './ColumnaTorneosDivision.module.css';
import ListaTorneosDecada from './ListaTorneosDecada.js';

const ColumnaTorneosDivision = (props) => {
  const pais = props.pais;
  const categoria = props.categoria;
  const division = props.division;
  const [torneos, setTorneos] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const idPais = pais ? pais.id : null;
  const codCategoria = categoria ? categoria.codigo : null;
  const idDivision = division ? division.id : null;

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const armarListaTorneos = (torneos) => {
      const torneosDesc = torneos.sort(
        (a, b) =>
          b.anioInicio * 10000 +
          b.mesInicio * 100 +
          b.diaInicio -
          (a.anioInicio * 10000 + a.mesInicio * 100 + a.diaInicio)
      );
      const decadas = Funciones.DecadasTorneos(torneosDesc);
      const agrupados = decadas.map((decada) => {
        const torneosDecada = torneosDesc.filter((torneo) => {
          return Funciones.TorneoEnDecada(torneo, decada);
        });
        return {
          id: decada,
          descripcion: 'Década de ' + decada + '-' + (decada + 9).toString().slice(-2),
          torneos: torneosDecada,
        };
      });
      setTorneos(agrupados);
    };

    if (codCategoria && idDivision) {
      const url =
        'paises/' + idPais + '/torneos?categoria=' + codCategoria + '&division=' + idDivision;
      fetchData(url, armarListaTorneos);
    } else {
      setTorneos([]);
    }
  }, [idPais, codCategoria, idDivision, fetchData]);

  const onTorneoElegido = (torneo) => {
    if (torneo) {
      props.onDatoElegido(Filtros.TORNEO, torneo);
    }
  };

  return (
    <React.Fragment>
      <div className={`${styles.botoneraDecadas}`}>
        <BotoneraDesplegable
          lista={torneos}
          renderBody={(item) => (
            <ListaTorneosDecada decada={item} onTorneoElegido={onTorneoElegido} />
          )}
          desplegarPrimero={true}
        />
      </div>
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default ColumnaTorneosDivision;
